module.exports = __webpack_public_path__ + "static/media/projects.7bd1af6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects.png
// module id = 29
// module chunks = 0